import React from 'react';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { InputLabel } from '@material-ui/core';

export default function TextFieldMobileNoAreaCode(props) {
  const phoneInputStyle = {
    width: '100%',
    height: '48px',
    borderRadius: '4px',
  };

  return (
    <>
      <InputLabel shrink id={props.name} style={{ marginBottom: '8px' }}>
        {props.label} <span style={{ color: 'red' }}>{props.required ? '*' : ''}</span>
      </InputLabel>
      <PhoneInput
        country={'us'}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        onInput={props.onInput}
        inputStyle={phoneInputStyle}
      />
    </>
  );
}
